export default __webpack_public_path__ + "static/tabs-hierarchy-dont-4d9334cd2e67111017c40eb069d3bfaea99f4126b9744764c7d1a9883a11bb6e.png";